import { toast } from "react-toastify"
import { logOutApi } from "../../apis/loginApi"
import {
  deleteUser,
  fetchAllAdminUser,
  fetchUser,
  updateUser,
} from "../../apis/userApi"
import {
  getUserPending,
  getUserSuccess,
  logOutSuccess,
  getAllAdminSuccess,
  getUserFail,
} from "./userSlice"

export const getUserProfile = () => async (dispatch) => {
  dispatch(getUserPending())

  const result = await fetchUser()

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(getUserSuccess(result.user))
    : dispatch(getUserFail(result))
}

export const updateUserInfoAction = (obj) => async (dispatch) => {
  const result = await updateUser(obj)

  result.status === "success" &&
    dispatch(getUserProfile()) &&
    dispatch(getAllAdminUsersAction())
  toast.success("Staff information updated!")
}

export const userLogOut = () => async (dispatch) => {
  const accessJWT = window.sessionStorage.getItem("accessJWT")
  const refreshJWT = window.localStorage.getItem("refreshJWT")
  // call api to logout
  await logOutApi({ accessJWT, refreshJWT })

  window.sessionStorage.removeItem("accessJWT")
  window.localStorage.removeItem("refreshJWT")
  dispatch(logOutSuccess())
}

export const getAllAdminUsersAction = () => async (dispatch) => {
  // call api to logout
  const result = await fetchAllAdminUser()

  if (result?.message === "logout user") {
    return dispatch(userLogOut())
  }

  result.status === "success"
    ? dispatch(getAllAdminSuccess(result.staffs))
    : dispatch(getUserFail(result))
}

export const deleteStaffUserAction = (_id) => async (dispatch) => {
  const { status, message } = await deleteUser(_id)

  status === "success"
    ? dispatch(getAllAdminUsersAction()) && toast.success(message)
    : toast[status](message)
}
